import { takeEvery } from 'redux-saga/effects';
import { ZONES_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_POSITION_BY_CAMERA_LIST,
  CREATE_POSITION,
  DELETE_POSITION,
  LOAD_ZONES_BY_CAMERA_LIST,
  CREATE_ZONE,
  DELETE_ZONE,
  SAVE_POSITION,
  SAVE_ZONE,
} from '../actions';

import createPosition from './createPosition';
import deletePosition from './deletePosition';
import loadPositionByCameraList from './loadPositionByCameraList';
import loadZonesByCameraList from './loadZonesByCameraList';
import deleteZone from './deleteZone';
import createZone from './createZone';
import savePosition from './savePosition';
import saveZone from './saveZone';

export default function* watchDashboard() {
  yield takeEvery(ZONES_MODULE + LOAD_POSITION_BY_CAMERA_LIST, loadPositionByCameraList);
  yield takeEvery(ZONES_MODULE + CREATE_POSITION, createPosition);
  yield takeEvery(ZONES_MODULE + SAVE_POSITION, savePosition);
  yield takeEvery(ZONES_MODULE + DELETE_POSITION, deletePosition);
  yield takeEvery(ZONES_MODULE + LOAD_ZONES_BY_CAMERA_LIST, loadZonesByCameraList);
  yield takeEvery(ZONES_MODULE + CREATE_ZONE, createZone);
  yield takeEvery(ZONES_MODULE + SAVE_ZONE, saveZone);
  yield takeEvery(ZONES_MODULE + DELETE_ZONE, deleteZone);
}
